export const UNKNOWN_COMPLAINT_COLOR = "rgb(170, 170, 170)";

export const VISIBLE_EVENTS = [
  "CREATE CASE",
  "SET DESTINATION",
  "SET COMPLAINT",
  "SET AGE",
  "SET GENDER",
  "SET TAG",
  "CALL TO ED",
  "VOICE CALL",
  "CALL ENDED",
  "REMOVE TAG",
  "ACKNOWLEDGE",
  "ASSIGN ROOM",
  "SET PATIENT INFO",
  "CLOSED BY EMS",
  "VIDEO CONSULT STARTED",
  "VIDEO CONSULT ENDED",
  "CASE TRANSFER INITIATED",
  "CASE TRANSFER CANCELLED",
  "CASE TRANSFER CONFIRMED",
  "MARKED AS ARRIVED"
];
